import Items from './Items'

module.exports = Items.reducer( null, 'SYSTEM', 'projectId', [ 'projectId' ] )

/*
import {combineReducers} from 'redux';
import {ArrayUtil} from 'blue-utils'
import Path from '@leverege/path'
import ObjectUtil from '@leverege/object-util'
import StringUtil from '@leverege/string-util'
import ArrayUtil from '@leverege/array-util'
import PatchOps from '@leverege/api-patch-ops'

import {SystemActions, Constants} from '~/actions'

const initialState = {
  status : "none",
  statusMessage : null, 
  projectId : null,
  total : 0,
  perPage : 100,
  items : [],
  loading : false,
  lookup : {}
};

function systems( state = initialState, action ) {

  switch ( action.type ) {

    case Constants.GET_SYSTEMS_STATUS : {
      let nState = Object.assign( {}, state )
      nState.status = action.status
      nState.statusMessage = action.statusMessage
      return nState
    }

    case Constants.GET_SYSTEMS: {

      let nState = {
        projectId : action.projectId,
        status : null,
        statusMessage : null,
        total : action.total,
        perPage : action.perPage,
        status : Constants.STATUS_DONE,
        statusMessage : null,
        search : action.search
      }

      if ( action.projectId != state.projectId || action.search != state.search ) {
        nState.items = new Array( action.total )
      } else {
        nState.items = [].concat( state.items )
      }
      if ( action.projectId != state.projectId ) {
        nState.lookup = {}
      } else {
        nState.lookup = {...state.lookup}
      }

      // copy new devices into the array
      for ( let n = 0, tn = action.startIndex; n < action.items.length; n++, tn++ ) {
        nState.items[tn] = action.items[n]
        nState.lookup[action.items[n].id] = action.items[n]
      }
      return nState
    }
      // TODO : MERGE IF STARTINDEX > 0
      // return {
      //   projectId : action.projectId,
      //   items : action.systems,
      //   hasMore : false
      // };

    case SystemActions.SYSTEMS_ERROR: {
      return { ...state,
               error : true,
               status : action.status,
               message : action.message };
    }

    case SystemActions.ADD_SYSTEM: {
      let copy = JSON.parse( JSON.stringify( state ) );
      copy.items.push( action.system )

      return copy;
    }

    case SystemActions.UPDATE_SYSTEM: {

      let nState = Object.assign( {}, state )
      nState.items = [].concat( state.items || [] )
      if ( action.system.projectId != state.projectId ) {
        // transfer out of project
        ArrayUtil.remove( nState.items, 'id', action.system.id )
      } else {
        ArrayUtil.replace( nState.items, 'id', action.system.id, action.system )
      }
      return nState
      // let copy = JSON.parse( JSON.stringify( state ) );
      // let index = ArrayUtil.replace( copy.items, 'id', action.system.id, action.system )
      // return copy;
    }

     case SystemActions.REMOVE_SYSTEM: {
      let copy = JSON.parse( JSON.stringify( state ) );
      let index = ArrayUtil.remove( copy.items, 'id', action.system.id )
      return copy;
    }
  }
  return state;
}

module.exports = systems;*/
